import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { NavigationContainer, useNavigationContainerRef } from "@react-navigation/native";
import { useFlipper } from "@react-navigation/devtools";
import { DripsyProvider } from "dripsy";
import { RootStackNavigator } from "./navigators";
import { themeLight } from "./theme";
export function App() {
    var navigationRef = useNavigationContainerRef();
    useFlipper(navigationRef);
    useEffect(function() {
        console.log("Hello, world!");
    }, []);
    return /*#__PURE__*/ _jsx(GestureHandlerRootView, {
        style: {
            flex: 1
        },
        children: /*#__PURE__*/ _jsx(SafeAreaProvider, {
            children: /*#__PURE__*/ _jsx(DripsyProvider, {
                theme: themeLight,
                children: /*#__PURE__*/ _jsx(NavigationContainer, {
                    ref: navigationRef,
                    children: /*#__PURE__*/ _jsx(RootStackNavigator, {})
                })
            })
        })
    });
}
